
import Vue from 'vue'
import { genesisIdToNetwork, networkToGenesisId } from '../utils'
import { nodeUrls, isSoloNode} from '@/create-connex'



export default Vue.extend({
    data: () => {
        return {
            searchString: ''
        }
    },
    computed: {
        routeName(): string { return this.$route.name ?? '' },
        isHome(): boolean { return this.routeName === 'home' },
        price() { return this.$state.price },
        nodeUrl() { return nodeUrls[genesisIdToNetwork(this.$connex.thor.genesis.id)] },
        network() {
            switch (genesisIdToNetwork(this.$connex.thor.genesis.id)) {
                case 'main': return 'MainNet'
                case 'test': return 'TestNet'
                case 'solo': return 'SoloNet'
            }
        },
        networks(): Array<{ name: string, label: string, href: string }> {
            if(isSoloNode) return [ {
                name: 'solo',
                label: 'SoloNet',
                href: '#/solo/'
                }]
            return [
                { name: 'main',label: 'MainNet', href: '#/main/' },
                { name: 'test',label: 'TestNet', href: '#/test/' },
                ...(isSoloNode ? [{ name:'solo',label: 'SoloNet', href: '#/solo/' }] : []),
            ]
        },
        switchableNetworks(): Array<{ name: string, label: string, href: string }> {
            return this.networks.filter(i =>  this.$connex.thor.genesis.id !== networkToGenesisId(i.name))
        },
        networkBadgeVariant() {
            return genesisIdToNetwork(this.$connex.thor.genesis.id) === 'main' ? 'light' : 'warning'
        },
        alters() {
            return [
                { title: 'Official Explorer', href: 'https://explore.vechain.org/' },
                { title: 'VeChainStats', href: 'https://vechainstats.com/' },
                { title: 'VeBlocks', href: 'https://www.veblocks.net/' }
            ]
        },
        tools() {
            return [
                { title: 'Inspector', href: 'https://inspector.vecha.in' },
                { title: 'Tokens', href: 'https://laalaguer.github.io/vechain-token-transfer/' },
                { title: 'B32', href: 'https://b32.vecha.in' },
            ].filter(i => !!i.href)
        },
        routeViewKey() {
            if (this.$route.matched.find(i => i.name === 'account')) {
                return `accounts-${this.$route.params.address.toLowerCase()}`
            }
            return this.$route.fullPath
        }
    },
    methods: {
        search() {
            const str = this.searchString.trim()
            this.searchString = ''
            if (!str) {
                return
            }
            this.$router.push({ name: 'search', query: { q: str } })
        },
        routed() {
            const name = this.$route.name
            const params = this.$route.params

            let subTitle
            if (this.$route.matched.find(r => r.name === 'account')) {
                subTitle = 'Account ' + this.$options.filters!.checksum(params.address)
            } else if (name === 'tx') {
                subTitle = 'Tx ' + params.id
            } else if (name === 'block') {
                subTitle = 'Block ' + params.id
            } else if (name === 'search') {
                subTitle = 'Search'
            }
            document.title = subTitle ? `Insight | ${subTitle}` : 'Insight - VeChain Explorer'
        }
    },
    watch: {
        '$route.path'() {
            this.routed()
        }
    },
    created() {
        this.routed()
    }
})
